/**
 * Dashboard Service — data fetching helpers specific to the dashboard page.
 */

import {
  collection,
  query,
  orderBy,
  limit as fbLimit,
  getDocs,
  Timestamp,
} from 'firebase/firestore';
import { db } from '@/config/firebase';
import type { AuditLog, AuditAction } from '@/types';
import type { Audience } from '@/types/auth.types';

// ─── Recent audit activity ─────────────────────────────────────────────────────

export async function getRecentAuditLogs(count = 10): Promise<AuditLog[]> {
  const q = query(
    collection(db, 'auditLogs'),
    orderBy('timestamp', 'desc'),
    fbLimit(count),
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => {
    const data = d.data() as Record<string, unknown>;
    const ts   = data.timestamp;
    return {
      id:              d.id,
      userId:          (data.userId as string)          ?? '',
      userDisplayName: (data.userDisplayName as string) ?? 'Unknown',
      userEmail:       (data.userEmail as string)       ?? '',
      action:          (data.action as AuditAction),
      timestamp:       ts instanceof Timestamp ? ts.toDate() : new Date(),
      audience:        (data.audience as Audience | null)   ?? null,
      monthNumber:     (data.monthNumber as number | null)  ?? null,
      weekNumber:      (data.weekNumber  as number | null)  ?? null,
      dayNumber:       (data.dayNumber   as number | null)  ?? null,
      recordId:        (data.recordId    as string | null)  ?? null,
      fieldsChanged:   (data.fieldsChanged  as string[])              ?? [],
      previousValues:  (data.previousValues as Record<string, unknown>) ?? {},
      newValues:       (data.newValues      as Record<string, unknown>) ?? {},
      metadata:        (data.metadata       as Record<string, unknown>) ?? {},
    };
  });
}
